import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { ArticlePreviewCardView, articlePreviewCardRootSx } from "./articlePreviewCardLayout";

const ArticleLinkedPreviewCard = ({ article }) => (
  <Box sx={articlePreviewCardRootSx}>
    <ArticlePreviewCardView article={article} />
  </Box>
);

ArticleLinkedPreviewCard.propTypes = {
  article: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    image: PropTypes.string,
    category: PropTypes.string,
    publishedAt: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
};

export default ArticleLinkedPreviewCard;
